if (!customElements.get("select-component")) {
	class SelectComponent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				elSelectNative: ".js-selectNative",
				elSelectCustom: ".js-selectCustom",
				elSelectCustomBox: ".select-custom--trigger",
				elSelectCustomOpts: ".select-custom--options",
				elSelectCustomTriggerText: ".select-custom--trigger-text",
				customOptionList: [".select-custom--option"],
			};

			this.domNodes = queryDomNodes(this.selectors, this);
			this.optionChecked = "";

			//this.setDefaultValue();
			this.initSelect();
		};

		setDefaultValue() {
			const { elSelectNative } = this.domNodes;
			const value = elSelectNative.options[elSelectNative.selectedIndex].value;
			const text = elSelectNative.options[elSelectNative.selectedIndex].text;
			this.updateCustomSelectChecked(value, text);
		}

		initSelect() {
			//this.classList.remove("m:hidden");
			const { elSelectNative, elSelectCustom, elSelectCustomBox } = this.domNodes;

			elSelectCustomBox.addEventListener("click", () => {
				const isClose = !elSelectCustom.classList.contains("isActive");
				if (isClose) {
					this.openSelect();
				} else {
					this.closeSelect();
				}
			});

			this.domNodes.customOptionList.forEach((option) => {
				option.addEventListener("click", (e) => {
					const value = e.target.getAttribute("data-value");
					elSelectNative.value = value;
					this.closeSelect();
					this.updateCustomSelectChecked(value, e.target.textContent);
					elSelectNative.dispatchEvent(new Event("change"));
					elSelectNative.dispatchEvent(new Event("click"));
				});
			});
		}

		openSelect() {
			const allCustomSelect = document.querySelectorAll("select-component");
			document.addEventListener("click", (e) => this.handleClickOutside(e));
			if (allCustomSelect.length > 0) {
				allCustomSelect.forEach((select) => {
					select.closeSelect();
				});
			}
			this.domNodes.elSelectCustom.classList.add("isActive");
		}

		closeSelect() {
			this.domNodes.elSelectCustom.classList.remove("isActive");
		}

		updateCustomSelectChecked(value, text) {
			const { elSelectCustomOpts, elSelectCustomTriggerText } = this.domNodes;
			const prevValue = this.optionChecked;
			const elPrevOption = elSelectCustomOpts.querySelector(`[data-value="${prevValue}"`);

			const elOption = elSelectCustomOpts.querySelector(`[data-value="${value}"`);

			if (elPrevOption) {
			elPrevOption.classList.remove("isActive");
			}

			if (elOption) {
			elOption.classList.add("isActive");
			}

			elSelectCustomTriggerText.textContent = text;
			this.optionChecked = value;
		}

		handleClickOutside(e) {
			const { elSelectCustom } = this.domNodes;
			const didClickedOutside = !elSelectCustom.contains(e.target);
			if (didClickedOutside) {
				this.closeSelect();
			}
		}
	}

	customElements.define("select-component", SelectComponent);
}
if (!customElements.get('localization-form')) {
	customElements.define(
    'localization-form',
		class LocalizationForm extends HTMLElement {
			constructor() {
				super();
				const select = this.querySelector("[data-localization-select]");
				select.addEventListener("change", e => {
					const value = e.target.value;
					const form = select.closest(".localization-form");
					const input = form.querySelector("input[data-localization-input]");
					input && input.setAttribute("value", value),
					input && form.submit()
				})
			}
		}
	);
}